ACC.addressDoctorWallet = {
    _autoload: [],

    init({ nextStep, userForm, actionBtn }) {
        if (!document.querySelector('.js-address-doctor')) {
            nextStep();
            return;
        }
        const {
            fetchAddressDoctor,
            bindOriginalAddressTemplateEvents,
            setRecommendedAddresses,
            setOriginalAddresses,
            showAddressDoctorBlock,
            setReenterAddress,
            showReenterAddressDoctorBlock,
        } = ACC.addressDoctorHED;

        const { bindReenterAddressButton, bindRecommendedTemplateEvents } = ACC.addressDoctorWallet;

        if (ACC.addressDoctorHED.editedRecommendedAddress) {
            ACC.buttonhelper.disable(actionBtn);
            fetchAddressDoctor(userForm)
                .then((response) => {
                    if (response.isValid) {
                        nextStep();
                        return;
                    }
                    // Address Doctor doesn't have suggested addresses
                    if (!response.suggestedAddresses.length) {
                        setReenterAddress(response.originAddress);
                        bindReenterAddressButton();
                        bindOriginalAddressTemplateEvents(nextStep);
                        showReenterAddressDoctorBlock(true);
                        return;
                    }
                    setRecommendedAddresses(response.suggestedAddresses);
                    setOriginalAddresses(response.originAddress);
                    showAddressDoctorBlock(true);
                    bindRecommendedTemplateEvents({
                        suggestedAddresses: response.suggestedAddresses,
                        userForm,
                        nextStep,
                    });
                    bindOriginalAddressTemplateEvents(nextStep);
                })
                .catch((error) => {
                    console.log(error);
                    nextStep();
                });
        } else {
            nextStep();
        }
    },

    bindReenterAddressButton() {
        const { showReenterAddressDoctorBlock, elements: { reenterADBtnClass } } = ACC.addressDoctorHED;
        const reenterAddressBtn = document.querySelector(reenterADBtnClass);
        const form = document.querySelector('#ccBillingAddressForm');

        reenterAddressBtn.addEventListener('click', () => {
            form.scrollIntoView({
                behavior: 'smooth',
            });
            showReenterAddressDoctorBlock(false);
        });
        ACC.addressDoctorHED.editedRecommendedAddress = true;
    },

    bindRecommendedTemplateEvents({ suggestedAddresses, userForm, nextStep }) {
        const { setDataToUserForm, showAddressDoctorBlock, elements: { recommendedADBtnClass } } = ACC.addressDoctorHED;
        const recommendedAddressBtn = document.querySelectorAll(recommendedADBtnClass);

        recommendedAddressBtn.forEach((item) => item.addEventListener('click', (event) => {
            event.preventDefault();
            ACC.buttonhelper.disable(recommendedAddressBtn);
            const id = event.target.getAttribute('data-id');
            const selectedAddress = suggestedAddresses.find((address, index) => index === Number(id));
            setDataToUserForm(selectedAddress, userForm);
            showAddressDoctorBlock(false);
            if (nextStep) {
                nextStep();
            }
        }));
    },

};
